/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const contextPathApi = process.env.REACT_APP_API_CONTEXT_PATH || process.env.MOCK_DEV_JSON_SERVER_CONTEXT || '';
export const contextPathUI = process.env.REACT_APP_UI_CONTEXT_PATH || process.env.MOCK_DEV_JSON_UI_CONTEXT || '';
export const integrationApiPath = `${contextPathApi}/npefiling-api`;

export const userServiceApiPath = `${contextPathApi}/user-api`;
export const configurationPath =
  process.env.REACT_APP_CONFIGURATION_SERVICE_PATH || `${contextPathApi}/configuration-service`;
export const integrationAdaptersApiPath =
  process.env.REACT_APP_INTEGRATION_CONSUMERS_SERVICE_PATH || `${contextPathApi}/adapters`;

export const websocketPath =
  process.env.REACT_APP_NOTIFICATION_SERVICE_PATH || `${contextPathApi}/notification-develop/notification-websocket`;
export const errorPermissionPath = '/errorpermission';
export const debug = process.env.REACT_APP_DEBUG_LEVEL === 'true';
export const lockTimeoutMillis = 300000; // 5 minutes since the last submission update
export const shortDateUIFormat = 'dd/MM/yyyy';
export const shortDateISO8601ServerFormat = 'yyyy-MM-dd';
export const uploadTimeout = 900000;
export const pctCallbackTimeout = 10000;
export const NETWORK_TIMEOUT = parseInt(process.env.REACT_APP_NETWORK_TIMEOUT || 60000);
export const defaultLocale = 'en';

export const scrollerSettings = {
  smooth: false,
  offset: 0,
  duration: 0,
  delay: 50,
};
